unit uStandings;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  uGlobal, WEBLib.JSON, System.DateUtils, WEBLib.REST, uHTTPHelper,
  WEBLib.GoogleChart, WEBLib.ExtCtrls, Vcl.Imaging.GIFImg, uGrandPrixTile,
  System.Generics.Collections;

type
  TfrmStandings = class(TForm)
    scrollbox: TScrollBox;
    pnChart: TPanel;
    chartSummary: TGoogleChart;
    pnTop: TPanel;
    btYear2025: TButton;
    btYear2026: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure btYear2025Click(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    year: integer;
    ChartDataLoaded: boolean;
    frmTemp: TFrmGrandPrixTile;
    forms: TObjectList<TFrmGrandPrixTile>;
    panels: TObjectList<TPanel>;

    [async]
    procedure FillSummaryChart; async;
    [async]
    procedure GetYearAllData(year: integer); async;
    procedure AddTile(joData: TJSONObject);
  protected procedure LoadDFMValues; override; end;

var
  frmStandings: TfrmStandings;

implementation

{$R *.dfm}

{ TfrmStandings }

procedure TfrmStandings.AddTile(joData: TJSONObject);
var
  wp: TPanel;
begin
  wp := TPanel.Create(scrollbox);
  wp.parent := scrollbox;
  wp.Align := alTop;

  wp.Caption := '';
  wp.BorderStyle := bsNone;
  wp.Height := 100;
  if Width > 600 then
  begin
    wp.Margins.left := (width - 600) div 2;
    wp.Margins.right := (width - 600) div 2;
  end else
  begin
    wp.Margins.left := 10;
    wp.Margins.right := 10;
  end;

  wp.Margins.top := 10;
  wp.Margins.Bottom := 10;
  wp.AlignWithMargins := True;
  wp.ElementClassName := 'pntilecontent';

  panels.Add(wp);

  Application.CreateForm(TFrmGrandPrixTile, wp.ElementID, frmTemp,
    procedure (AForm: TObject)
    begin
      if (AForm <> nil) then
      begin
        forms.add(AForm as TFrmGrandPrixTile);
        forms[forms.Count - 1].LoadData(joData);
        panels[forms.Count - 1].Height := forms[forms.Count - 1].pnTileContent.Height;
      end;
    end
  );

end;

procedure TfrmStandings.FillSummaryChart;
var
  joReq, joResp, joData: TJSONObject;
  jaResp: TJSONArray;
  i, status, points, max: integer;
  username: string;
  seriesItem: TGoogleChartSeriesItem;
begin

  joReq := TJSONObject.Create;
  joReq.AddPair('year', year);
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/getyearstandings/', httpPOST, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      max := 0;
      chartSummary.BeginUpdate;
      jaResp := TJSONArray(joResp);
      chartSummary.Title := 'Standings ' + year.ToString;
      if (jaResp.Count = 0) then
        chartSummary.Title := chartSummary.Title + ' (noch keine Daten)';

      chartSummary.Appearance.Legend.Position := gcpNone;
      chartSummary.Series.Clear;
      chartSummary.Options.Clear;
      chartSummary.Appearance.Stacked := gcsDisabled;

      if (jaResp.Count > 0) then
      begin
        seriesItem := chartSummary.series.add;

        seriesItem.ChartType := gctBar;
        seriesItem.Line.PointSize := 6;
        seriesItem.Line.LineWidth := 8;
        seriesItem.AnnotationType := gcatData;
        seriesItem.AnnotationText := '';
      end;


      for i := 0 to jaResp.Count - 1 do
      begin
        joData := jaResp.Items[i] as TJSONObject;
        username := joData.GetJSONValue('username');
        points := StrToInt(joData.GetJSONValue('points'));
        if (points > max) then
          max := points;

        //Ab in das Chart mit den Daten
        seriesItem.Values.AddSinglePoint(points, username);

      end;

      //Proforma - Series um Annotation zu sehen

      seriesItem := chartSummary.series.add;

      seriesItem.ChartType := gctBar;
      seriesItem.Line.PointSize := 2;
      seriesItem.Line.LineWidth := 2;
      seriesItem.AnnotationType := gcatNone;
      seriesItem.AnnotationText := '';
      seriesItem.Values.AddSinglePoint(0, '');

      chartSummary.Appearance.HAxis.MaxValue := max;

      ChartDataLoaded := True;
      chartSummary.Enabled := True;
      chartSummary.EndUpdate;



    finally
      jaResp.free;
    end;
  end else
  begin
    ShowMessage('Fehler bei GetYearStandings, Status: ' + status.ToString);
  end;

  GetYearAllData(year);
end;



procedure TfrmStandings.GetYearAllData(year: integer);
var
  joReq, joResp: TJSONObject;
  jaResp: TJSONArray;
  status, i : integer;
begin
  //Holt sich alle Daten für das Jahr und erstellt daraus die GrandPrix-Tiles
  joReq := TJSONObject.Create;
  joReq.AddPair('year', year);
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/getyearalldata/', httpPOST, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      jaResp := TJSONArray(joResp);
      for i := 0 to jaResp.Count - 1 do
      begin
        //GrandPrix's
        AddTile(TJSONObject(jaResp[i]));
      end;
    finally
      jaResp.free;
    end;
  end;
  pnChart.top := 0;

end;

procedure TfrmStandings.btYear2025Click(Sender: TObject);
begin
  if (forms <> nil) then
    forms.Clear;
  if (panels <> nil) then
    panels.Clear;


  //Bei noch mehr Jahren etwas eleganter lösen
  if (Sender = btYear2025) then
  begin
    btYear2025.ElementHandle.classList.remove('btn-outline-primary');
    btYear2025.ElementHandle.classList.add('btn-primary');
    btYear2026.ElementHandle.classList.remove('btn-primary');
    btYear2026.ElementHandle.classList.add('btn-outline-primary');
  end else
  begin
    btYear2026.ElementHandle.classList.remove('btn-outline-primary');
    btYear2026.ElementHandle.classList.add('btn-primary');
    btYear2025.ElementHandle.classList.remove('btn-primary');
    btYear2025.ElementHandle.classList.add('btn-outline-primary');
  end;

  ChartDataLoaded := False;
  chartSummary.Enabled := False;
  year := StrToInt((Sender as TButton).Caption);
  FillSummaryChart;
end;

procedure TfrmStandings.WebFormCreate(Sender: TObject);
begin
  year :=  YearOf(Now);
  ChartDataLoaded := False;
  forms := TObjectList<TfrmGrandPrixTile>.create;
  panels := TObjectList<TPanel>.Create;

  if Width > 600 then
  begin
    pnChart.Margins.left := (width - 600) div 2;
    pnChart.Margins.right := (width - 600) div 2;
  end else
  begin
    pnChart.Margins.left := 10;
    pnChart.Margins.right := 10;
  end;

  FillSummaryChart;

end;

procedure TfrmStandings.WebFormDestroy(Sender: TObject);
var
  i : integer;
begin
  forms.Clear;
  panels.Clear;
end;

procedure TfrmStandings.WebFormResize(Sender: TObject);
var
  ch: TJSObject;
  i: integer;
  wp: TPanel;
begin
  if ChartDataLoaded then
  begin
    chartSummary.SetOption('width', chartSummary.width.ToString);
    ch := chartSummary.Chart;
    asm
      ch.draw();
    end;
  end;

  if Width > 600 then
  begin
    pnChart.Margins.left := (width - 600) div 2;
    pnChart.Margins.right := (width - 600) div 2;
  end else
  begin
    pnChart.Margins.left := 10;
    pnChart.Margins.right := 10;
  end;


  if (panels <> nil) then
  begin
    for i := 0 to panels.Count - 1 do
    begin
      wp := panels[i];
      if Width > 600 then
      begin
        wp.Margins.left := (width - 600) div 2;
        wp.Margins.right := (width - 600) div 2;
      end else
      begin
        wp.Margins.left := 10;
        wp.Margins.right := 10;
      end;
    end;
  end;

end;

procedure TfrmStandings.LoadDFMValues;
begin
  inherited LoadDFMValues;

  scrollbox := TScrollBox.Create(Self);
  pnChart := TPanel.Create(Self);
  chartSummary := TGoogleChart.Create(Self);
  pnTop := TPanel.Create(Self);
  btYear2025 := TButton.Create(Self);
  btYear2026 := TButton.Create(Self);

  scrollbox.BeforeLoadDFMValues;
  pnChart.BeforeLoadDFMValues;
  chartSummary.BeforeLoadDFMValues;
  pnTop.BeforeLoadDFMValues;
  btYear2025.BeforeLoadDFMValues;
  btYear2026.BeforeLoadDFMValues;
  try
    Name := 'frmStandings';
    Width := 640;
    Height := 640;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -19;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    Visible := True;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    scrollbox.SetParentComponent(Self);
    scrollbox.Name := 'scrollbox';
    scrollbox.Left := 0;
    scrollbox.Top := 60;
    scrollbox.Width := 640;
    scrollbox.Height := 580;
    scrollbox.Align := alClient;
    scrollbox.BorderStyle := bsSingle;
    scrollbox.ChildOrder := 3;
    scrollbox.Color := 16316922;
    pnChart.SetParentComponent(scrollbox);
    pnChart.Name := 'pnChart';
    pnChart.AlignWithMargins := True;
    pnChart.Left := 3;
    pnChart.Top := 3;
    pnChart.Width := 634;
    pnChart.Height := 331;
    pnChart.Margins.Bottom := 10;
    pnChart.Align := alTop;
    pnChart.BorderColor := 16316922;
    pnChart.BorderStyle := bsNone;
    pnChart.Caption := 'pnChart';
    pnChart.ChildOrder := 1;
    pnChart.Color := 16316922;
    pnChart.ShowCaption := False;
    pnChart.TabOrder := 0;
    chartSummary.SetParentComponent(pnChart);
    chartSummary.Name := 'chartSummary';
    chartSummary.Left := 0;
    chartSummary.Top := 0;
    chartSummary.Width := 634;
    chartSummary.Height := 331;
    chartSummary.Align := alClient;
    chartSummary.ChildOrder := 1;
    chartSummary.Enabled := False;
    chartSummary.Font.Charset := DEFAULT_CHARSET;
    chartSummary.Font.Color := clWindowText;
    chartSummary.Font.Height := -16;
    chartSummary.Font.Name := 'Segoe UI';
    chartSummary.Font.Style := [];
    chartSummary.Appearance.Animation.Startup := False;
    chartSummary.Appearance.Legend.Position := gcpNone;
    chartSummary.Appearance.HAxis.AutoMaxMinValue := False;
    chartSummary.Series.Clear;
    with chartSummary.Series.Add do
    begin
      AnnotationType := gcatData;
      Color := clBlue;
      Tag := -1;
    end;
    chartSummary.Title := 'Standings';
    pnTop.SetParentComponent(Self);
    pnTop.Name := 'pnTop';
    pnTop.Left := 0;
    pnTop.Top := 0;
    pnTop.Width := 640;
    pnTop.Height := 60;
    pnTop.Align := alTop;
    pnTop.BorderColor := 16316922;
    pnTop.BorderStyle := bsNone;
    pnTop.ChildOrder := 1;
    pnTop.Color := 16316922;
    pnTop.TabOrder := 1;
    btYear2025.SetParentComponent(pnTop);
    btYear2025.Name := 'btYear2025';
    btYear2025.Left := 32;
    btYear2025.Top := 11;
    btYear2025.Width := 96;
    btYear2025.Height := 38;
    btYear2025.Caption := '2025';
    btYear2025.ElementClassName := 'btn btn-outline-primary';
    btYear2025.ElementFont := efCSS;
    btYear2025.HeightPercent := 100.000000000000000000;
    btYear2025.WidthPercent := 100.000000000000000000;
    SetEvent(btYear2025, Self, 'OnClick', 'btYear2025Click');
    btYear2026.SetParentComponent(pnTop);
    btYear2026.Name := 'btYear2026';
    btYear2026.Left := 134;
    btYear2026.Top := 11;
    btYear2026.Width := 96;
    btYear2026.Height := 38;
    btYear2026.Caption := '2026';
    btYear2026.ChildOrder := 1;
    btYear2026.ElementClassName := 'btn btn-primary';
    btYear2026.ElementFont := efCSS;
    btYear2026.HeightPercent := 100.000000000000000000;
    btYear2026.WidthPercent := 100.000000000000000000;
    SetEvent(btYear2026, Self, 'OnClick', 'btYear2025Click');
  finally
    scrollbox.AfterLoadDFMValues;
    pnChart.AfterLoadDFMValues;
    chartSummary.AfterLoadDFMValues;
    pnTop.AfterLoadDFMValues;
    btYear2025.AfterLoadDFMValues;
    btYear2026.AfterLoadDFMValues;
  end;
end;

end.


